import React from 'react';

const Callback = () => <div></div>;

export default Callback;
